import Job from '@polleverywhere/core/lib/models/job'
import { buildJobData, generateCrud } from './helpers'

export default function () {
  const path = '/api/activities'
  const crud = generateCrud(path)

  return {
    clear ({ entities, name, presenterId = null }) {
      // when clearing shared activities, use the presenter id passed in
      if (!presenterId) presenterId = entities[0].owner_id
      const jobData = Object.assign(buildJobData(entities), {
        name,
        presenter_id: presenterId
      })
      const job = Job.create(`${path}/clear`, jobData)
      return job.promise
    },
    copy (entities, targetId = null, targetUserIds) {
      const jobData = buildJobData(entities)
      if (targetUserIds) {
        // can't specify both target group and user
        jobData.target_user_ids = targetUserIds
        targetId = null
      }
      const job = targetId
        ? Job.create(`${path}/copy/to_group/${targetId}`, jobData)
        : Job.create(`${path}/copy`, jobData)
      return job.promise
    },
    move (entities, targetId, targetUserId = null) {
      const jobData = buildJobData(entities)
      if (targetUserId) jobData.group_id = targetId
      const job = targetUserId
        ? Job.create(`${path}/move/to_user/${targetUserId}`, jobData)
        : Job.create(`${path}/move/to_group/${targetId}`, jobData)
      return job.promise
    },
    lock (entities) {
      const jobData = buildJobData(entities)
      const job = Job.create(`${path}/lock`, jobData)
      return job.promise
    },
    unlock (entities) {
      const jobData = buildJobData(entities)
      const job = Job.create(`${path}/unlock`, jobData)
      return job.promise
    },
    trash (entities) {
      const jobData = buildJobData(entities)
      const job = Job.create(`${path}/trash`, jobData)
      return job.promise
    },
    delete (entities) {
      const jobData = buildJobData(entities)
      const job = Job.create(`${path}/delete`, jobData)
      return job.promise
    },
    downloadScreenshots (entities) {
      const jobData = buildJobData(entities)
      return generateCrud(`${path}/screenshot`).create(jobData)
    },
    downloadSlides (entities) {
      const jobData = buildJobData(entities)
      return generateCrud(`${path}/slide`).create(jobData)
    },
    downloadCSVs (entities) {
      const jobData = buildJobData(entities)
      return generateCrud(`${path}/csv`).create(jobData)
    },
    multiEdit (entities = [], options = {}) {
      const jobData = buildJobData(entities)
      const job = Job.create(`${path}/multi_edit`, {
        ...jobData,
        ...options
      })
      return job.promise
    },
    read: crud.read
  }
}
